import type { IBillingAddress } from "../interfaces/payment-method";

/** Registered funding card selected from the saved-card picker. */
export interface FundingInstrumentSaved {
  source: "saved";
  paymentMethodId: string;
  brand: string;
  last4: string;
  fundingMethod?: "DEBIT_CARD" | "CREDIT_CARD";
  /**
   * One-shot VGS CVV alias from a just-completed alta. Memory-only — never
   * persist. Cleared after first rail prepare attempt. List picks omit this.
   */
  pendingCvvToken?: string;
}

/**
 * Pre-validated funding card awaiting register. Add-card promotes this to
 * `saved` before leaving the processing page; confirm only prepares the rail.
 */
export interface FundingInstrumentNew {
  source: "new";
  cardholderName: string;
  pan: string;
  expiry: string;
  billingAddress: IBillingAddress;
  cvsValidationId: string;
  cvvToken: string;
  numberToken: string;
  brand: string;
  last4: string;
}

export type FundingInstrument = FundingInstrumentSaved | FundingInstrumentNew;

export const isFundingInstrumentReady = (
  instrument: FundingInstrument | null
): boolean => {
  if (!instrument) return false;
  if (instrument.source === "saved") {
    return Boolean(instrument.paymentMethodId);
  }
  return Boolean(
    instrument.cvsValidationId &&
      instrument.cvvToken &&
      instrument.numberToken
  );
};

export const fundingInstrumentLabel = (
  instrument: FundingInstrument
): { brand: string; last4: string } => ({
  brand: instrument.brand,
  last4: instrument.last4,
});
